import PartnershipMaterialsPage from './PartnershipMaterialsPage';

export default PartnershipMaterialsPage;
